//lib
import { Icon } from "@iconify/react/dist/iconify.js";

//redux
import { useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { Logo, Sample } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";
import CommonTitle from "../../../components/common/common.title";
import CommonProduct from "../../../components/common/common.product";
import ShopFilter from "./product.carousel";
import { useState } from "react";
import useWindowDimension from "../../../components/hook/use.window.dimension";
import { Swiper, SwiperSlide } from "swiper/react";

export default function ProductDetail({ product }) {
  const { width } = useWindowDimension();
  const [activeDetail, setActiveDetail] = useState("Description");
  const { productInfoLoading } = useSelector((state) => state.product);

  const detailList = [
    {
      label: "Description",
      description: product?.description || "",
    },
    {
      label: "Sizing Chart",
      images:
        product?.media?.length > 0
          ? product.media.filter(
              (item) => item.collection_type === "sizing_chart"
            )
          : [],
    },
    {
      label: "Maintenance Care",
      description:
        product?.care_instruction ||
        "<p>To ensure the longevity of your fashion items, please follow these care instructions:</p><p><br></p><ul><li><strong>Clothing</strong>: Wash with similar colors, follow the care label instructions, and avoid excessive heat drying.</li><li><strong>Shoes</strong>: Store in a cool, dry place and clean with a soft cloth or brush. Avoid prolonged exposure to water.</li><li><strong>Bags &amp; Accessories</strong>: Wipe with a damp cloth and store in dust bags when not in use. Avoid direct sunlight and moisture.</li><li><strong>Jewelry</strong>: Keep away from water, perfumes, and harsh chemicals to prevent tarnishing.</li></ul><p><br></p><p>Proper care will help maintain the quality and appearance of your items for years to come.</p>",
    },
    {
      label: "Shipping & Return",
      description:
        '<p>We offer fast and reliable shipping worldwide.</p><p><br></p><p>1. <strong>Processing Time</strong>: Orders are processed within <strong>1-3 business days</strong>.</p><p>2.<strong> Delivery Time</strong>:</p><p class="ql-indent-1">a. Standard Shipping: <strong>5-10 business days</strong></p><p class="ql-indent-1">b. Express Shipping: <strong>2-5 business days</strong></p><p>3. <strong>Tracking</strong>: Once your order is shipped, you will receive a tracking number via email.</p><p>4. <strong>International Shipping</strong>: Additional customs duties may apply depending on your location.</p><p><br></p><p>For urgent orders, please select <strong>Express Shipping</strong> at checkout.</p>',
    },
  ];

  const detailInfo = detailList.find((detail) => detail.label === activeDetail);

  return (
    <Container className="product-detail">
      {width < 750 ? (
        <Swiper
          grabCursor={true}
          slidesPerView="auto"
          spaceBetween={0}
          className="_row category-list"
        >
          {detailList.map(
            (detail, detailIndex) =>
              ((product?.media?.length > 0 &&
                product.media.filter(
                  (item) => item.collection_type === "sizing_chart"
                )?.length > 0 &&
                detailIndex === 1) ||
                detailIndex !== 1) && (
                <SwiperSlide
                  className={`_col detail ${
                    activeDetail === detail.label ? "--active" : ""
                  } pointer`}
                  key={detailIndex}
                  onClick={() => setActiveDetail(detail.label)}
                >
                  <p className="_label detail-title">{detail.label}</p>
                </SwiperSlide>
              )
          )}
        </Swiper>
      ) : (
        <Row className="flex-nowrap">
          {detailList.map(
            (detail, detailIndex) =>
              ((product?.media?.length > 0 &&
                product.media.filter(
                  (item) => item.collection_type === "sizing_chart"
                )?.length > 0 &&
                detailIndex === 1) ||
                detailIndex !== 1) && (
                <Col
                  className={`_col detail ${
                    activeDetail === detail.label ? "--active" : ""
                  } pointer`}
                  key={detailIndex}
                  onClick={() => setActiveDetail(detail.label)}
                >
                  <p className="_label detail-title">{detail.label}</p>
                </Col>
              )
          )}
        </Row>
      )}
      {productInfoLoading ? (
        <Row className="row-center">
          <Icon icon="eos-icons:bubble-loading" className="_svg loading" />
        </Row>
      ) : (
        <Col
          className={`${
            detailInfo.images?.length > 0 ? "col-center gap-5" : ""
          } pt-5`}
        >
          {detailInfo.images?.length > 0 ? (
            detailInfo.images.map((image, imageIndex) => (
              <a href={image.url} target="_blank" rel="noopener noreferrer">
                <Image className="_img sizing-chart" src={image.url} />
              </a>
            ))
          ) : (
            <p
              className="_label detail-description"
              dangerouslySetInnerHTML={{
                __html: detailInfo.description,
              }}
            />
          )}
        </Col>
      )}
    </Container>
  );
}
